module.exports = __webpack_public_path__ + "static/logo_full_spacing-f5e27566b63ec0c3e1b3a834131dfa73.svg";